export default "__VITE_PUBLIC_ASSET__9235fd17__"